import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db, provider } from "../firebase";
import { signInWithPopup, signInWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc, getDoc, collection, query, where, getDocs } from "firebase/firestore";

export default function Register() {
  const [isLogin, setIsLogin] = useState(false);
  const [form, setForm] = useState({
    nom: "",
    prenom: "",
    email: "",
    password: "",
    confirmPassword: "",
    numero: ""
  });
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "numero" && !/^\d*$/.test(value)) return;
    setForm({ ...form, [name]: value });
  };

  // 🔹 Connexion Google
  const handleGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      const userRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(userRef);

      if (!docSnap.exists()) {
        await setDoc(userRef, {
          nom: user.displayName || "",
          email: user.email,
          numero: "",
          createdAt: new Date(),
          type: "google",
        });
      }

      navigate("/accueil");
    } catch (err) {
      setError("Erreur Google : " + err.message);
    }
  };

  // 🔹 Inscription / Connexion manuelle
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!form.email || !form.password) {
      setError("Veuillez remplir tous les champs requis.");
      return;
    }

    if (!isLogin && form.password !== form.confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    try {
      if (isLogin) {
        // ✅ Connexion manuelle : vérifier si l'utilisateur existe dans Firestore
        const usersRef = collection(db, "users");
        const q = query(usersRef, where("email", "==", form.email), where("password", "==", form.password));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          setError("Email ou mot de passe incorrect ❌");
          return;
        }

        setMessage("Connexion réussie ✅");
        setTimeout(() => navigate("/accueil"), 1200);
      } else {
        // ✅ Inscription : enregistrer l’utilisateur dans Firestore
        const usersRef = collection(db, "users");
        const q = query(usersRef, where("email", "==", form.email));
        const existing = await getDocs(q);

        if (!existing.empty) {
          setError("Cet email est déjà utilisé ❌");
          return;
        }

        const newUserRef = doc(usersRef);
        await setDoc(newUserRef, {
          nom: form.nom,
          prenom: form.prenom,
          email: form.email,
          password: form.password, // 🔒 (⚠️ tu pourras plus tard le hasher)
          numero: form.numero,
          createdAt: new Date(),
          type: "manuel",
        });

        setMessage("Inscription réussie ✅");
        setTimeout(() => navigate("/accueil"), 1200);
      }
    } catch (err) {
      setError("Erreur : " + err.message);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>{isLogin ? "Connexion" : "Inscription"}</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          {!isLogin && (
            <>
              <input type="text" name="nom" placeholder="Nom" value={form.nom} onChange={handleChange} required style={styles.input} />
              <input type="text" name="prenom" placeholder="Prénom" value={form.prenom} onChange={handleChange} required style={styles.input} />
              <input type="text" name="numero" placeholder="Numéro de téléphone" value={form.numero} onChange={handleChange} required style={styles.input} />
            </>
          )}
          <input type="email" name="email" placeholder="Adresse e-mail" value={form.email} onChange={handleChange} required style={styles.input} />
          <input type="password" name="password" placeholder="Mot de passe" value={form.password} onChange={handleChange} required style={styles.input} />
          {!isLogin && (
            <input type="password" name="confirmPassword" placeholder="Confirmer le mot de passe" value={form.confirmPassword} onChange={handleChange} required style={styles.input} />
          )}
          {error && <p style={styles.error}>{error}</p>}
          {message && <p style={styles.success}>{message}</p>}
          <button type="submit" style={styles.button}>
            {isLogin ? "Se connecter" : "S'inscrire"}
          </button>
        </form>

        <button onClick={handleGoogle} style={styles.googleButton}>
          🔗 Se connecter avec Google
        </button>

        <p style={styles.switchText}>
          {isLogin ? "Pas encore de compte ?" : "Déjà un compte ?"}{" "}
          <span onClick={() => setIsLogin(!isLogin)} style={styles.link}>
            {isLogin ? "S'inscrire" : "Se connecter"}
          </span>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #e3f2fd, #ffffff)",
  },
  card: {
    backgroundColor: "#fff",
    padding: "2rem",
    borderRadius: "10px",
    boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
    width: "90%",
    maxWidth: "400px",
    textAlign: "center",
  },
  title: {
    fontSize: "1.6rem",
    marginBottom: "1rem",
    color: "#333",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "0.8rem",
  },
  input: {
    padding: "0.9rem",
    border: "1px solid #ccc",
    borderRadius: "6px",
    fontSize: "0.9rem",
  },
  button: {
    padding: "0.9rem",
    backgroundColor: "#1976d2",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  googleButton: {
    marginTop: "1rem",
    backgroundColor: "#db4437",
    color: "#fff",
    padding: "0.8rem",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  switchText: {
    marginTop: "1rem",
    fontSize: "0.9rem",
  },
  link: {
    color: "#1976d2",
    cursor: "pointer",
    fontWeight: "bold",
  },
  error: {
    color: "red",
    fontSize: "0.85rem",
  },
  success: {
    color: "green",
    fontSize: "0.85rem",
  },
};
